import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__container" }
const _hoisted_2 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_3 = { class: "profile-creation-wizard__content" }
const _hoisted_4 = { class: "details-form__item" }
const _hoisted_5 = { class: "details-form__item__title" }
const _hoisted_6 = { class: "custom-font-text" }
const _hoisted_7 = { class: "experiences" }
const _hoisted_8 = { class: "profile-creation-wizard__content-footer" }

import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {Education} from '@/profile-creation-wizard/components/for-completion/domain/Profile';
    import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
    import {useTranslation} from '@malt/vue3-use';
    import {computed, inject, onBeforeMount, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import EducationComponent from './components/Education.vue';
    import YourEducationSide from './YourEducationSide.vue';

    const stepName = 'completion_experience';

    const dataHeapTooltipID = 'profile-creation-tooltip-education';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'YourEducationStep',
  setup(__props) {

    const router = useRouter();
    const {msg} = useTranslation();

    const profileRepository = inject(DI.profileCompletionRepository);

    const refEducations = ref<HTMLElement>();
    const educations = ref<Education[]>([]);
    const hasValidFieldPart = ref(false);
    const meta = computed(() => router.currentRoute.value.meta);
    const isStepOptionnal = computed(() => meta.value.funnelMode === ProfileCreationFunnelMode.FREELANCER);
    const progressPercentage = computed(() => meta.value.progressPercentage);
    const stepNavigator = new StepNavigator(router, meta.value.previousStep, meta.value.nextStep);

    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    onBeforeMount(async () => {
        educations.value = await fetchEducations();

        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#completion-your-education-bottom-sheet',
            dataHeapTooltipID,
            refEducations.value,
            'div.profile-creation-wizard',
        );
        bottomSheetDisplayer.value.mounted();
    });

    // Fetch educations
    async function fetchEducations() {
        return await profileRepository!.fetchEducations();
    }

    // StepNavigator action
    function goToPrevious(): void {
        stepNavigator.previous();
    }
    function goNext(): void {
        stepNavigator.next();
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refEducations",
    ref: refEducations,
    class: "profile-creation-wizard ff-bottom-fixed-cta"
  }, [
    _createVNode(_component_joy_progress_bar, { percentage: progressPercentage.value }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(StepMobileHeader, {
            "step-name": stepName,
            "onClick:previous": goToPrevious
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.education.title')) + " ", 1),
              _createElementVNode("p", _hoisted_6, [
                _createElementVNode("a", {
                  class: "open-bottom-sheet",
                  onClick: openBottomSheet
                }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.education.title')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(educations.value, (education) => {
              return (_openBlock(), _createBlock(EducationComponent, {
                key: education.id,
                education: education
              }, null, 8, ["education"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_joy_progress_bar, {
            percentage: progressPercentage.value,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(StepActions, {
            "step-name": stepName,
            "show-button-previous": false,
            "show-button-skip": isStepOptionnal.value,
            "is-disabled-button-next": !hasValidFieldPart.value,
            "is-hidden-button-skip": hasValidFieldPart.value,
            "onClick:next": goNext,
            "onClick:skip": goNext,
            "onClick:previous": goToPrevious
          }, null, 8, ["show-button-skip", "is-disabled-button-next", "is-hidden-button-skip"])
        ])
      ]),
      _createVNode(YourEducationSide)
    ])
  ], 512))
}
}

})